const { Component,render } = wp.element;
import App from './App.js';

render(<App />, document.getElementById('amn_affaires_form'));
